import { useQuery } from '@tanstack/react-query';
import apiClient from '../../lib/api';

/**
 * 特定の患者に紐づく家族メンバー一覧を取得するカスタムフック
 */
export const useFamiliesByPatient = (patientId: number | null) => {
  return useQuery({
    queryKey: ['familiesByPatient', patientId],
    queryFn: async () => {
      if (!patientId) {
        throw new Error('Patient ID is required');
      }
      return await apiClient.getFamiliesByPatient(patientId);
    },
    enabled: !!patientId && !!apiClient.getIdToken(),
  });
};

export default useFamiliesByPatient;
